import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface DeleteScheduledMessageParams {
  id: string
}

const deleteScheduledMessage = async ({ id }: DeleteScheduledMessageParams): Promise<void> => {
  await api.delete(`/scheduled-message/${id}`)
}

export const useDeleteScheduledMessage = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, DeleteScheduledMessageParams>({
    mutationFn: deleteScheduledMessage,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.scheduledMessageDeleted'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['scheduled-messages'] }),
        queryClient.invalidateQueries({ queryKey: ['scheduled-message', variables.id] }),
      ])
    },
  })
}

